export default "__VITE_ASSET__CHAy1uPe__"